import { render, staticRenderFns } from "./category-wizard.vue?vue&type=template&id=87278202&scoped=true&"
import script from "./category-wizard.vue?vue&type=script&lang=ts&"
export * from "./category-wizard.vue?vue&type=script&lang=ts&"
import style0 from "./category-wizard.vue?vue&type=style&index=0&id=87278202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87278202",
  null
  
)

export default component.exports